/* eslint-disable max-len */
const desktop = theme => {
  return {
    cardContainer: {
      maxWidth: 174,
    },
  };
};

const mobile = theme => {
  return {
    cardContainer: {
      padding: 10,
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      // maxWidth: 174,
      height: '100%',
      // justifyContent: 'space-around',
      // justifyContent: 'flex-start',
      // textAlign: 'center',
      // alignItems: 'center',
      transition: 'transform 0.2s ease-in-out',
      borderRadius: '15px',
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%)',
      '&:hover': {
        transform: 'translateY(-5px)',
      },
    },
    imageContainer: {
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      '& img': {
        width: '120px',
        height: '120px',
      },
    },
    boxContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '100%',
    },
    textContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
    },
    cardTitle: {
      color: '#FFF',
      // fontFamily: 'SF Pro Display',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 800,
      lineHeight: '20px',
    },
    cardContent: {
      color: '#FFF',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '15px',
      opacity: 0.5,
    },
    conetentContainer: {
      background: 'transparent url(/images-mobile/home/phaseTwo/centerBox.webp)',
      backgroundPosition: '100% 0%',
      backgroundSize: '100% 100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      alignItems: 'center',
      '& img': {
        marginBottom: '2px',
      },
      height: '35px',
      lineHeight: '15px',
      paddingBottom: '3px',
    },
    buttonText: {
      display: 'inline-block',
      fontSize: '14px',
      fontWeight: 600,
      fontFamily: 'PingFang HK',
      position: 'relative',
      '&:before': {
        content: 'attr(data-text)',
        background: 'linear-gradient(to bottom,#261603 0%, #6E4D21 100%)',
        '-webkit-text-stroke': '2px transparent',
        '-webkit-background-clip': 'text',
      },
      '&:after': {
        content: 'attr(data-text)',
        left: 0,
        top: 0,
        position: 'absolute',
        backgroundImage:
          'linear-gradient(180deg, #FFFAC8 20%, #BC954F 61.08%, #E4C46F 69.24%, #E9C35D 78%)',
        ' -webkit-background-clip': 'text',
        color: 'transparent',
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
